import { render, staticRenderFns } from "./CustomPriorityInput.vue?vue&type=template&id=df46d850&scoped=true"
import script from "./CustomPriorityInput.vue?vue&type=script&lang=js"
export * from "./CustomPriorityInput.vue?vue&type=script&lang=js"
import style0 from "./CustomPriorityInput.vue?vue&type=style&index=0&id=df46d850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df46d850",
  null
  
)

export default component.exports